// Import the functions you need from the SDKs you need
import app from "firebase/app"
// utilizamos firestore
import 'firebase/firestore'
// import 'firebase/app'
// vamos a utilizar la uthentication
import 'firebase/auth'


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBAZ-2MMFGP-zfRWvHchb3jFcAwQ4PcCKk",
    authDomain: "crud-udemy-react-959d6.firebaseapp.com",
    databaseURL: "https://crud-udemy-react-959d6-default-rtdb.firebaseio.com",
    projectId: "crud-udemy-react-959d6",
    storageBucket: "crud-udemy-react-959d6.appspot.com",
    messagingSenderId: "129200769846",
    appId: "1:129200769846:web:2447eb42ea2c0b8db08197"
};

// Initialize Firebase
app.initializeApp(firebaseConfig);

// configuramos una constante
const db = app.firestore()
// configuramos los metodos para hacer la uth del usuario
const auth = app.auth()



// como necesitamos esto envarios archivos vamos a exportarlo
// db ---> colecciones
// auth --> para la autenticacion
export { auth, db }
